module.exports = __webpack_public_path__ + "img/agree.58f63484.svg";